import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = { class: "i-tabs" };
import ViewModeSwitchButton from "./ViewModeSwitchButton.vue";
import { ref, watch } from "vue";
import cookies from "js-cookie";
import EventBus from "../../../events/EventBus";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ViewModeSwitch',
    setup: function (__props) {
        var mode = ref(cookies.get('grid-view-mode') === 'more' ? 'more' : 'less');
        var gridElement = document.querySelector('.catalog_items');
        watch(mode, function (value) {
            cookies.set('grid-view-mode', value, { path: '/', expires: 365 });
            if (value === 'more') {
                gridElement.classList.add('grid--more');
            }
            else {
                gridElement.classList.remove('grid--more');
            }
            EventBus.emit('products:view-mode-change');
        });
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
                _createVNode(ViewModeSwitchButton, {
                    mode: "less",
                    modelValue: mode.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((mode).value = $event); }),
                    onClick: _cache[1] || (_cache[1] = function ($event) { return (mode.value = 'less'); })
                }, null, 8 /* PROPS */, ["modelValue"]),
                _cache[4] || (_cache[4] = _createTextVNode()),
                _createVNode(ViewModeSwitchButton, {
                    mode: "more",
                    modelValue: mode.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) { return ((mode).value = $event); }),
                    onClick: _cache[3] || (_cache[3] = function ($event) { return (mode.value = 'more'); })
                }, null, 8 /* PROPS */, ["modelValue"])
            ]));
        };
    }
});
